import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Globe, Phone, MessageCircle, Mail } from "lucide-react";
import { SITE, telLink, mailLink, waLink } from "@/lib/site";
import { services, areas } from "@/data/seo";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0A192F] text-slate-300">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-2 lg:grid-cols-5 gap-10">
      <div className="lg:col-span-2">
        <div className="flex items-center gap-2">
          <span className="inline-flex h-10 w-10 rounded-2xl bg-white text-[#0A192F] font-display font-extrabold items-center justify-center text-xl">B</span>
          <span className="font-display font-bold text-white text-lg tracking-tight">BoxB Solutions</span>
        </div>
        <p className="mt-4 text-slate-300 max-w-md leading-relaxed">
          {SITE.tagline} Professional house and office removals, packing and cleaning across Cardiff and South Wales.
        </p>
        <div className="mt-6 space-y-2 text-sm">
          <a href={telLink} className="flex items-center gap-2 hover:text-white"><Phone className="h-4 w-4" /> {SITE.phone}</a>
          <a href={waLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white"><MessageCircle className="h-4 w-4" /> WhatsApp</a>
          <a href={mailLink} className="flex items-center gap-2 hover:text-white"><Mail className="h-4 w-4" /> {SITE.email}</a>
          <a href={SITE.website} className="flex items-center gap-2 hover:text-white"><Globe className="h-4 w-4" /> www.boxb.uk</a>
        </div>
        <div className="mt-6 flex items-center gap-3">
          <a href="#" aria-label="Facebook" className="h-9 w-9 rounded-full border border-white/15 inline-flex items-center justify-center hover:bg-white/10"><Facebook className="h-4 w-4" /></a>
          <a href="#" aria-label="Instagram" className="h-9 w-9 rounded-full border border-white/15 inline-flex items-center justify-center hover:bg-white/10"><Instagram className="h-4 w-4" /></a>
          <a href="#" aria-label="Twitter" className="h-9 w-9 rounded-full border border-white/15 inline-flex items-center justify-center hover:bg-white/10"><Twitter className="h-4 w-4" /></a>
        </div>
      </div>

      <div>
        <h4 className="text-white font-display font-semibold">Services</h4>
        <ul className="mt-4 space-y-2 text-sm">
          {Object.values(services).map((s) => (
            <li key={s.slug}><Link to={`/services/${s.slug}`} className="hover:text-white">{s.shortName}</Link></li>
          ))}
          <li><Link to="/services" className="hover:text-white font-medium">All services →</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-display font-semibold">Areas</h4>
        <ul className="mt-4 space-y-2 text-sm">
          {Object.values(areas).slice(0, 6).map((a) => (
            <li key={a.slug}><Link to={`/areas/${a.slug}`} className="hover:text-white">Movers in {a.name}</Link></li>
          ))}
          <li><Link to="/areas" className="hover:text-white font-medium">All areas →</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-display font-semibold">Company</h4>
        <ul className="mt-4 space-y-2 text-sm">
          <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
          <li><Link to="/#reviews" className="hover:text-white">Reviews</Link></li>
          <li><Link to="/#faq" className="hover:text-white">FAQ</Link></li>
          <li><Link to="/#contact" className="hover:text-white">Contact</Link></li>
          <li><Link to="/login" className="hover:text-white">Sign in</Link></li>
        </ul>
        <h4 className="mt-6 text-white font-display font-semibold">Legal</h4>
        <ul className="mt-4 space-y-2 text-sm">
          <li><a href="#" className="hover:text-white">Privacy Policy</a></li>
          <li><a href="#" className="hover:text-white">Terms &amp; Conditions</a></li>
          <li><a href="#" className="hover:text-white">Cookie Policy</a></li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-slate-400">
        <p>© {new Date().getFullYear()} BoxB Solutions. All rights reserved.</p>
        <p>Cardiff · Newport · Swansea · South Wales</p>
      </div>
    </div>
  </footer>
);
